import(/* webpackMode: "eager" */ "/var/www/pechatnov/src/app/not-found.tsx");
